<template>
    <div class="detail">
        <div class="swiper-box">
            <swiper>
                <swiper-slide v-for="(item,index) in product.img_path" :key="index"><img :src="item"></swiper-slide>
            </swiper>
        </div>
        <!-- 商品信息 -->
        <div class="info-box">
            <p class="c_1a fs_32 lh_40 mt_20">{{product.name}}</p>
            
            <div class="flex__between__center mt_30">
                <div class="lh_40">
                    <span class="fs_40 c_main" v-if="product.integral">{{product.integral}}<span class="fs_26">积分</span></span>
                    <span class="fs_26 c_main" v-if="product.integral&&product.money!='0.00'">+</span>
                    <span class="fs_30 c_main" v-if="product.money!='0.00'">{{product.money}}<span class="fs_24">元</span></span>
                </div>
                <span class="fs_26 c_80 lh_40">库存{{product.stock}} | 已兑{{product.sales}}</span>
            </div>
        </div>
        <!-- 简介 -->
        <div class="modular" v-if="product.description">
            <div class="modular__title">
                <span class="fs_36 c_1a fw_500">商品详情</span>
            </div>
            <div v-html="product.description" class="modular__content">{{product.description}}</div>
        </div>
        <!-- 底部操作 -->
        <div class="footer" @click='show=!show'>
            <button>立即兑换</button>
        </div>

        <!-- 规格modal -->
        <div>
            <div class='layer' v-show='show' @click='show=!show'></div>
            <div class='model' v-show='show'>
                <div class='model__info'>
                    <img :src='product.cover_img'>
                    <div class='flex__null__between model__info__right'>
                        <div class='flex__between__center'>
                            <div class="lh_40">
                                <span class="fs_40 c_main" v-if="product.integral">{{product.integral}}<span class="fs_26">积分</span></span>
                                <span class="fs_26 c_main" v-if="product.integral&&product.money!='0.00'">+</span>
                                <span class="fs_30 c_main" v-if="product.money!='0.00'">{{product.money}}<span class="fs_24">元</span></span>
                            </div>
                            <span class='jcicon jcicon-error c_b3' @click='show=!show'></span>
                        </div> 
                        <span class='fs_24 c_98'>库存：{{product.stock}}</span>
                    </div>
                </div>

                <div class='flex__between__center model__num'>
                    <span class='fs_28 c_33'>数量</span>
                    <div class='stepper_components'>
                        <div class='count' @click='reduce'>
                            <span class='jcicon jcicon-jianhaocu c_4d fs_22'></span>
                        </div>
                        <div class='count count--big'>
                            <span class='fs_24'>{{orders.number}}</span>
                        </div>
                        <div class='count' @click='add'>
                            <span class='jcicon jcicon-jiahao c_4d fs_22'></span>
                        </div>
                    </div>
                </div>

                <div class='model__footer' @click="sure">
                    <button>确定</button>
                </div>
            </div>
        </div>
        <!-- 浮层菜单 -->
        <back-top v-back-top v-scroll-show:800="is_top" :show="is_top.value" :url="'/Integral/Index'"></back-top>
    </div>
</template>
<script>
export default {
    name: 'Detail',
    data(){
        return{
            is_top:{value:false},
            product:{
                img_path:[]
            },
            orders:{
                user_id: localStorage.user_id,
                number: 1,
                product_id: '',
                lng: 0,
                lat: 0,
            },
            show: false //规格modal
        }
    },
    methods:{
        // 减
        reduce() {
            if (this.orders.number > 1) {
                this.orders.number=this.orders.number - 1;
            } else {
                this.$toast('不能再减了');
            }
        },
        // 加
        add() {
            if (!this.product.stock) {
                this.orders.number=this.orders.number + 1;
            } else if (this.orders.number < this.product.stock) {
                this.orders.number=this.orders.number + 1;
            }else{
                this.orders.number=this.product.stock;
                this.$toast('不能大于' + this.product.stock);
            }
        },
        // 下单
        sure() {
            this.$wx.getLocation();
            // 立即兑换
            this.axios.post('/wechat.php/Integral/getOrderReadyData', this.orders).then(
                res => {
                    if (res.data.code == 1) {
                        if (1){
                            this.$router.push({
                                path:'/Integral/Order',
                                query: {
                                    product_id: this.orders.product_id,
                                    number: this.orders.number,
                                    lat:1,
                                    lng:1
                                }
                            })
                        }else{
                            this.$toast('库存不足');
                        }
                    }
            })
        }
    },
    mounted(){
        this.httpPost({
            url:'/Integral/getProductDetailData',
            params:{product_id: this.$route.params.id},
            loading:1
        }).then(
            res=>{
                if(res.code==1){
                    this.orders.product_id=res.data.product.id;
                    this.product=res.data.product;
                    this.product.description=res.data.product.description.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ');
                }
            }
        )
    }
}
</script>

<style scoped>
.swiper-box img{
    width:750px;
    height:600px;
}
.info-box{
    position: relative;
    padding: 25px 30px 25px;
    background: #fff;
}
/* 模块 */
.modular{
    margin-top: 15px;
    padding: 0 30px 30px;
    background: #fff;
}
.modular__title{
    padding: 30px 0;
}
.modular__content{
    padding-bottom:30px;
}
/* modal */
.layer{
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    background: rgba(0,0,0,0.6);
    z-index: 2;
}

.footer{
    position: fixed;
    bottom: 0;
    width: 100%;
}
.footer button{
    width: 100%;
    height: 98px;
    line-height: 98px;
    font-size: 32px;
    background: #F93A42;
    color: #fff;
}

/* 规格model */
.model{
    position: fixed;
    bottom: 0;
    z-index: 3;
    width: 100%;
    background: #fff;
}
.model__info{
    display: flex;
    padding: 30px 30px 0;
}
.model__info img{
    display: block;
    width: 220px;
    height: 220px;
    margin-top: -60px;
    border: 2px solid #E6E6E6;
    border-radius: 10px;
    background: #fff;
}
.model__info__right{
  width: 440px;
  margin-left: 30px;
}
.size-table{
    width: 120px;
    height: 30px;
    background: #1a1a1a;
    line-height: 30px;
}
.model__spec{
    margin: 0 30px;
    padding: 30px 0;
    border-bottom: 2px solid #e6e6e6;
}
.model__spec__item{
    min-width: 60px;
    margin: 20px 20px 0 0;
    padding: 0 20px;
    height: 60px;
    text-align: center;
    font-size: 26px;
    color: #989898;
    border: 2px solid #CBCBCB;
    border-radius: 6px;
}
.active{
    color: #F93A42;
    border: 2px solid #F93A42;
}
.actives{
    background: #e8e8e8;
    color: #c8c9cc;
    border: none;
}
.model__num{
    height: 180px;
    padding: 0 30px;
}
/* 计步器 */
.stepper_components{
    display: flex;
    justify-content: space-between;
    width: 200px;
    margin-top: 20px;
    border: 2px solid #e6e6e6;
}
.stepper_components .count{
    width: 66px;
    height: 60px;
    line-height: 60px;
    text-align: center;
}
.stepper_components .count--big{
    width: 85px;
    height: 60px;  
    border-right: 2px solid #e6e6e6;
    border-left: 2px solid #e6e6e6;
    text-align: center;
}

.model__footer button{
    width: 100%;
    height: 98px;
    line-height: 98px;
    font-size: 32px;
    background: #F93A42;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/integral/Detail.vue